import { ThemeProvider } from '@emotion/react';
import { createTheme, Grid, Button } from '@mui/material';
import { PATHS } from 'commons/paths';
import { cvtClassName } from 'commons/utils';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { Link } from 'react-router-dom';

export const UnauthHeader = () => {
  const headerClass = [
    'fixed',
    'top-0',
    'left-0',
    'w-full',
    'h-20',
    'text-[--c-text]',
    'bg-[--c-header-background]',
  ];

  const headerInnerClass = [
    'fixed',
    'top-5',
    'left-1/2',
    'w-full',
    'max-w-7xl',
    'mx-auto',
    'px-5',
    'items-center',
    'justify-between',
    '-translate-x-1/2',
  ];

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
    },
  });
  const { t: tCommon } = useTranslationWithLang('commons');

  return (
    <div className="z-20 relative">
      <header className={cvtClassName(headerClass)}>
        <nav className={cvtClassName(headerInnerClass)}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <div className="grow-0 shrink basis-[150px]">
              <ThemeProvider theme={theme}>
                <Button
                  variant="text"
                  component={Link}
                  to={PATHS.LOGIN}
                  disableElevation
                  aria-label={tCommon('TU000_047')}
                >
                  <img
                    src="/logo_spotu.png"
                    alt="logo"
                    role="img"
                    title={tCommon('TU000_047')}
                  ></img>
                </Button>
              </ThemeProvider>
            </div>
          </Grid>
        </nav>
      </header>
    </div>
  );
};
